import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FormValues {
  riskScore: string;
  riskCategory: string;
  individualSingleTransactionFrom: string;
  individualSingleTransactionId?: string;
  individualSingleTransactionTo: string;
  individualMultiTransactionFrom: string;
  individualMultiTransactionId?: string;
  individualMultiTransactionTo: string;
  corporateSingleTransactionFrom: string;
  corporateSingleTransactionId?: string;
  corporateSingleTransactionTo: string;
  corporateMultiTransactionFrom: string;
  corporateMultiTransactionId?: string;
  corporateMultiTransactionTo: string;
  currencyId: string;
}

export interface TransactionsVolumesRiskFormState {
  isLoading: boolean;
  formValues?: FormValues;
  itemId?: string;
  requestInProgress: boolean;
  submitSuccess?: boolean;
}

const initialState: TransactionsVolumesRiskFormState = {
  isLoading: false,
  requestInProgress: false,
};

export const transactionsVolumesRiskFormSlice = createSlice({
  name: 'transactionsVolumesRiskForm',
  initialState,
  reducers: {
    getTransactionVolumeRiskValues: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.itemId = action.payload;
    },
    getTransactionVolumeRiskValuesSuccess: (
      state,
      action: PayloadAction<FormValues>,
    ) => {
      state.isLoading = false;
      state.formValues = action.payload;
    },
    onSubmit: (state, action: PayloadAction<FormValues>) => {
      state.submitSuccess = false;
      state.formValues = action.payload;
      state.requestInProgress = true;
    },
    onSubmitSuccess: (state) => {
      state.requestInProgress = false;
      state.submitSuccess = true;
    },
    clearTransactionVolumeRiskFormState: (state) => {
      state.requestInProgress = false;
      state.formValues = undefined;
      state.submitSuccess = undefined;
      state.itemId = undefined;
    },
  },
});

export const {
  getTransactionVolumeRiskValues,
  getTransactionVolumeRiskValuesSuccess,
  onSubmit,
  onSubmitSuccess,
  clearTransactionVolumeRiskFormState,
} = transactionsVolumesRiskFormSlice.actions;

export default transactionsVolumesRiskFormSlice.reducer;
